import React, { useState, useEffect } from 'react';
import SupervisorLayout from '../../components/SupervisorLayout';
import { fetchSupervisorTicketDetail } from '../../api/supervisor';
import './SupervisorTicketDetailsView.css';

const SupervisorTicketDetailsView = ({ ticket, bankDesc, date, onBack }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError('');
    fetchSupervisorTicketDetail(ticket)
      .then((d) => { if (!cancelled) setData(d); })
      .catch(() => { if (!cancelled) setError('Impossible de charger le ticket — verifie que le serveur backend tourne.'); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [ticket]);

  const details = data ? data.lines : [];
  const totalPoints = details.reduce((s, r) => s + r.points, 0);
  const totalAmount = details.reduce((s, r) => s + r.amount, 0);

  return (
    <SupervisorLayout>
      <div className="svtdv-wrapper">
        <div className="svtdv-card">
          <div className="svtdv-card-header">
            <span className="svtdv-card-title">Ticket's Details</span>
          </div>

          <div className="svtdv-info">
            <div className="svtdv-info-row">
              <span className="svtdv-info-label">Lottery</span>
              <span className="svtdv-info-val">{data ? data.tirage_name : ''}</span>
            </div>
            <div className="svtdv-info-row">
              <span className="svtdv-info-label">Bank</span>
              <span className="svtdv-info-val">{bankDesc}</span>
            </div>
            <div className="svtdv-info-row">
              <span className="svtdv-info-label">Ticket</span>
              <span className="svtdv-info-val">{ticket}</span>
            </div>
            <div className="svtdv-info-row">
              <span className="svtdv-info-label">Date</span>
              <span className="svtdv-info-val">{date}</span>
            </div>
          </div>

          <div className="svtdv-table-bar"></div>

          {error && <p className="svtdv-error">{error}</p>}
          {loading && <p className="svtdv-loading">Chargement...</p>}

          {!loading && !error && (
            <table className="svtdv-table">
              <thead>
                <tr>
                  <th>Move Type</th>
                  <th>Points</th>
                  <th>Number</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                {details.map((r, i) => (
                  <tr key={i} className={r.bold ? 'svtdv-row-bold' : 'svtdv-row-light'}>
                    <td>{r.moveType}</td>
                    <td>{r.points}</td>
                    <td>{r.number}</td>
                    <td>{r.amount.toFixed(2)}</td>
                  </tr>
                ))}
                <tr className="svtdv-total-row">
                  <td><strong>Total:</strong></td>
                  <td><strong>{totalPoints}</strong></td>
                  <td></td>
                  <td><strong>{totalAmount.toFixed(2)}</strong></td>
                </tr>
              </tbody>
            </table>
          )}
        </div>

        <div className="svtdv-actions">
          <button className="svtdv-back-btn" onClick={onBack}>↩</button>
          <button className="svtdv-menu-btn">☰<br /><span>Menu</span></button>
        </div>
      </div>
    </SupervisorLayout>
  );
};

export default SupervisorTicketDetailsView;
